import React from 'react';
import moment from 'moment';

/** fir pill styles */
import styles from 'Assets/sass/core/vars.scss';
import { Tooltip, Pill } from 'Components';
import { LinearProgress } from '@mui/material';

//international
import { createIntl, createIntlCache } from "react-intl";
import locales from 'Locales';
import { defaultLocale } from 'Core/defaultValues';
import { round, roundTo } from 'Core/data/Helpers'
import { useIntl } from 'react-intl';

const cache = createIntlCache();

const intl = createIntl({ locale: defaultLocale, messages: locales[defaultLocale] }, cache)

const { messages } = intl;


/////////////////////////////////////////

export const getProgressLineClassColor = (status, value) => {
  let color = '';
  if (status === 'PastDue') {
    color = 'purple-linear-progress';
  } else if (status === 'Due') {
    color = 'red-linear-progress';
  } else if (status === 'DueNow') {
    color = 'orange-linear-progress';
  } else if (status === 'DueSoon') {
    color = 'orange-linear-progress';
  } else if (status === 'Scheduled') {
    color = 'green-linear-progress';
  } else if (status == 'Done') {
    color = calculatedColor(value);
  }
  return color;
};

export const calculatedColor = (value) => {
  let color = '';
  if (value <= 50) {
    color = 'green-linear-progress';
  } else if (value > 50 && value < 100) {
    color = 'orange-linear-progress';
  } else if (value >= 100) {
    color = 'red-linear-progress';
  }

  return color;
};

export const setContactId = (contacts) => {
  let newDate = contacts.map(contact => {
    return { ...contact, contactId: contact.id }
  });
  return newDate;
}

export const getIdentifierByUnits = (units) => {
  // Return the ids of the units that we send by parameter
  let ids = [];
  units?.length &&
    (units.forEach(unit => {
      if (unit?.deviceId || unit?.CUnits_id || unit?.unitId) {
        ids = [...ids, unit?.deviceId || unit?.CUnits_id || unit?.unitId];
      }
    }))
  return ids;
}

export const getUnitsByIdFromVehicleList = (ids, unitsList) => {
  // Get the units by id from a unit list
  const newUnits = [];
  ids.forEach(id => {
    const findUnit = unitsList.find(unit => unit.CUnits_id == id || unit.deviceId == id);
    if (findUnit) {
      newUnits.push(findUnit);
    }
  });
  return newUnits;
}

export const truncateString = (str, num) => {
  // If the length of str is less than or equal to num
  // just return str--don't truncate it.
  if (str?.length <= num) {
    return str
  }
  // Return str truncated with '...' concatenated to the end of str.
  return str?.slice(0, num) + '...'
}


////////////////////////////////////////////////// drivers task repetitive code

export const statusPill = (tasks) => {

  const {messages} = useIntl()

  let color = '';
  let tooltip = '';

  const { status } = tasks;
  if (status === 'PastDue') {
    color = styles.purple;
    tooltip = messages['pastDue'];
  } else if (status === 'Due') {
    color = styles.red;
    tooltip = messages['due'];
  } else if (status === 'DueNow') {
    color = styles.orange;
    tooltip = messages['dueNow'];
  } else if (status === 'DueSoon') {
    color = styles.orange;
    tooltip = messages['dueSoon'];
  } else if (status === 'Scheduled') {
    color = styles.green;
    tooltip = messages['scheduled'];
  } else if (status === 'Done') {
    color = styles.black;
    tooltip = messages['done'];
  }

  return <Pill style={{ width: 110 }} item={{ name: tooltip, color: color }} />;
}


export const getDurationTime = (startDate, endDate) => {
  // get the duration between two dates
  let duration;
  const endMoment = moment(endDate).utc();
  const startDateMoment = moment.utc(startDate);
  duration = moment.duration(endMoment.diff(startDateMoment));
  return duration;
}


const defineDuration = (duration) => {
  let definedDuration
  if (duration >= 30) {
    definedDuration = `${Number(duration / 30).toFixed(2)} ${messages["months"]}`
  } else if (duration >= 1) {
    definedDuration = `${Number(duration).toFixed(2)} ${messages["days"]}`
  } else {
    definedDuration = `${Number(duration * 24).toFixed(2)} ${messages["hours"]}`
  }

  return definedDuration
}

export const progressBarLog = (taskLog) => {

  const { startDate, logDate, dueDate } = taskLog;


  let duration = getDurationTime(startDate, dueDate);
  let duration2 = getDurationTime(startDate, logDate);
  const asDaysStartEnd = duration2._milliseconds / (1000 * 60 * 60 * 24)

  //validate if total time from start to end is invalid
  if (asDaysStartEnd < 0) {
    return null
  }

  const timeRelation = (duration2._milliseconds / duration._milliseconds)

  const percentage = timeRelation * 100

  const timeRelationMilli = timeRelation * duration2._milliseconds

  const asDays = timeRelationMilli / (1000 * 60 * 60 * 24)

  let barColor = getProgressLineClassColor("Done", percentage);

  return (
    <Tooltip placement="top" title={`(${String(Number(percentage).toFixed(2)).replace(".00", "")}%) ${String(defineDuration(asDays)).replace(".00", "")}/${String(defineDuration(asDaysStartEnd)).replace(".00", "")}`}>
      <div style={{ padding: '5px 10px 10px 0px' }}>
        <LinearProgress variant="determinate" className={barColor} value={percentage} />
      </div>
    </Tooltip>
  )

}


export const progressBarDue = (tasks) => {
  const { createdOn, frequency, timeUnit, lastMaintenanceDate, status, dueDate } = tasks;
  let duration = getDuration(lastMaintenanceDate, createdOn, dueDate);
  let diffDays = diffValue(timeUnit, duration);

  let diff = Math.floor(diffDays);

  if (diffDays >= 1) {
    diff = Math.floor(diffDays);
  } else {
    diff = Number((diffDays).toFixed(2));
  }

  const momentDueDate = moment(dueDate).utc();
  // if now is greater than the dueDate and does not exits lastMaintenanceDate
  if (momentDueDate <= moment().utc() && !lastMaintenanceDate) {
    diff = diff + frequency;
  }
  let porcentaje = diff > 0 ? frequency > 0 ? ((diff) / frequency) * 100 : 0 : 0;
  let intPorcentaje = Math.round(porcentaje);
  let totalPorcentaje = !isNaN(intPorcentaje) ? (intPorcentaje > 100 ? 100 : intPorcentaje) : 0;
  let barColor = getProgressLineClassColor(status, intPorcentaje);
  return (
    <Tooltip placement="top" title={`(${intPorcentaje}%) ${diff}/${frequency} ${timeUnit}`}>
      <div style={{ padding: '5px 10px 10px 0px' }}>
        <LinearProgress variant="determinate" className={barColor} value={totalPorcentaje} />
      </div>
    </Tooltip>
  )
}


export const getDuration = (lastMaintenanceDate, createdOn, dueDate) => {
  // get the duration between two dates
  let duration;
  const nowMoment = moment().utc();
  if (!lastMaintenanceDate) {
    const creationDate = moment.utc(createdOn);
    const momentDueDate = moment.utc(dueDate);
    if (momentDueDate <= nowMoment) {
      duration = moment.duration(nowMoment.diff(momentDueDate));
    } else {
      duration = moment.duration(nowMoment.diff(creationDate));
    }
  } else {
    const lastMaintenanceDateMoment = moment.utc(lastMaintenanceDate);
    duration = moment.duration(nowMoment.diff(lastMaintenanceDateMoment));
  }
  return duration;
}

export const diffValue = (timeUnit, duration) => {
  let diffDays = ""
  if (timeUnit === "Days") {
    diffDays = duration.asDays();
  } else if (timeUnit === "Hours") {
    diffDays = duration.hours();
  } else if (timeUnit === "Months") {
    diffDays = duration.months();
  }
  return diffDays;
}

export const formatVehicleStatus = (status) => {
  //let vehicleStatus

  /*switch (status) {
    case "PastDue":
      vehicleStatus = "Past Due"
      break
    case "DueSoon":
      vehicleStatus = "Due Soon"
      break
    default:
      vehicleStatus = status
      break
  }*/


  return messages[status[0].toLowerCase() + status.slice(1)]
}

export const getPriority = (status) => {
  switch (status) {
    case "PastDue":
      return 1
    case "Due":
      return 2
    case "DueSoon":
      return 3
    case "Scheduled":
      return 4
    case "Done":
      return 5
    default:
      return 0
  }
}

//REGION CREATE MAINTENANCE BARS

export const getMaintenanceBar = (type, status, startValue, endValue, currentValue, messages, label) => {
  let title = ""
  let percentage = 0;
  let color = '';
  if (status === 'PastDue') {
    color = 'purple-linear-progress';
  } else if (status === 'Due') {
    color = 'red-linear-progress';
  } else if (status === 'DueNow') {
    color = 'orange-linear-progress';
  } else if (status === 'DueSoon') {
    color = 'orange-linear-progress';
  } else if (status === 'Scheduled') {
    color = 'green-linear-progress';
  }

  if (!startValue || !endValue || !currentValue) return "";

  switch (type) {
    case "time":
      let daysStart = moment.utc(startValue?.toString())
      let daysEnd = moment.utc(endValue?.toString())
      let daysNow = moment.utc(currentValue) || moment().utc()

      const diff = moment.duration(daysEnd.diff(daysStart));
      const diffNow = moment.duration(daysNow.diff(daysStart));

      percentage = (diffNow.asMinutes() / (diff.asMinutes() || 1)) * 100
      if (percentage < 0) percentage = 0

      let currentTime = ""
      if (diffNow.asMonths() >= 1) currentTime = `${round(diffNow.asMonths(), 1)}  ${messages['vehicleDetailView_months']}`
      else if (diffNow.asDays() >= 1) currentTime = `${round(diffNow.asDays(), 1)}  ${messages['vehicleDetailView_days']}`
      else if (diffNow.asHours() >= 1) currentTime = `${round(diffNow.asHours(), 1)}  ${messages['vehicleDetailView_hours']}`
      else if (diffNow.asMinutes() >= 1) currentTime = `${round(diffNow.asMinutes(), 1)}  ${messages['vehicleDetailView_minutes']}`
      let totalTime = ""
      if (diff.asMonths() >= 1) totalTime = `${round(diff.asMonths(), 1)}  ${messages['vehicleDetailView_months']}`
      else if (diff.asDays() >= 1) totalTime = `${round(diff.asDays(), 1)}  ${messages['vehicleDetailView_days']}`
      else if (diff.asHours() >= 1) totalTime = `${round(diff.asHours(), 1)}  ${messages['vehicleDetailView_hours']}`
      else if (diff.asMinutes() >= 1) totalTime = `${round(diff.asMinutes(), 1)}  ${messages['vehicleDetailView_minutes']}`

      //extra validation to prevent wrong progrees bar with wrong data
      //if( isFinite(percentage) && !isNaN(percentage) && isFinite(currentTime.replace(/[^0-9]/g,'')) && !isNaN(currentTime.replace(/[^0-9]/g,''))
      // && isFinite(totalTime.replace(/[^0-9]/g,'')) && !isNaN(totalTime.replace(/[^0-9]/g,'')) )
      //{
      //title = `(${Math.round(percentage)}%) ${ currentTime || 0 }/${totalTime}`;
      //}

      //Removing percentage
      title = `${currentTime || 0}/${totalTime}`;
      break;

    case "hours":
      break;

    case "odometer":
      let totalOdometer = endValue - startValue
      if (totalOdometer < 0) totalOdometer = 1
      //fix value
      currentValue = currentValue - startValue;
      //calculate
      percentage = (currentValue / (totalOdometer || 1)) * 100;
      if (percentage < 0) percentage = 0

      //title = `(${Math.round(percentage)}%) ${currentValue < 0 ? 0 : Math.round(currentValue)}/${Math.round(totalOdometer)} ${messages['vehicleDetailView_miles']}`;
      //Removing percentage
      title = `${currentValue < 0 ? 0 : Math.round(currentValue)}/${Math.round(totalOdometer)}`;

      break;

    case "engineHours":
      let totalEngineH = endValue - startValue;
      if (totalEngineH < 0) totalEngineH = 1
      //fix value
      currentValue = currentValue - startValue;
      //calculate
      percentage = (currentValue / (totalEngineH || 1)) * 100;

      if (percentage < 0) percentage = 0

      //extra validation to prevent wrong progrees bar with wrong data
      //if( isFinite(percentage) && !isNaN(percentage) && isFinite(currentValue) && !isNaN(currentValue)  && isFinite(totalEngineH) && !isNaN(totalEngineH) )
      //{
      //title = `(${Math.round(percentage)}%) ${currentValue < 0 ? 0 : Math.round(currentValue)}/${Math.round(totalEngineH)} ${messages['vehicleDetailView_engineHours']}`;
      //}
      //Removing percentage
      title = `${currentValue < 0 ? 0 : Math.round(currentValue)}/${Math.round(totalEngineH)}`;

      break;
  }

  if (status == 'Done') {
    color = calculatedColor(percentage);
  }

  if(!label){
    return (
      <div>
        <div style={{ padding: '5px 10px 10px 0px' }}>
          <Tooltip title={`${Math.round(percentage)}%`} placement="bottom">
            <LinearProgress
              variant="determinate"
              className={color}
              value={percentage > 100 ? 100 : percentage}
            />
          </Tooltip>
        </div>
        <div>{title}</div>
      </div>
    )
  }
  else {
    return `${Math.round(percentage)}% ${title}` 
  }
}

export const getMaintenanceValue = (type, startValue, endValue, currentValue) => {
  let percentage = 0;

  if (!type || !startValue || !endValue || !currentValue) return percentage;

  switch (type) {
    case "time":
      let daysStart = moment.utc(startValue?.toString())
      let daysEnd = moment.utc(endValue?.toString())
      let daysNow = moment.utc(currentValue) || moment().utc()

      const diff = moment.duration(daysEnd.diff(daysStart));
      const diffNow = moment.duration(daysNow.diff(daysStart));

      percentage = (diffNow.asMinutes() / diff.asMinutes()) * 100
      if (percentage < 0) percentage = 0
      break;

    case "hours":
      break;

    case "odometer":
      let totalOdometer = endValue - startValue
      //fix value
      currentValue = currentValue - startValue;
      //calculate
      percentage = (currentValue / totalOdometer) * 100;
      if (percentage < 0) percentage = 0
      break;

    case "engineHours":
      let totalEngineH = endValue - startValue;
      //fix value
      currentValue = currentValue - startValue;
      //calculate
      percentage = (currentValue / totalEngineH) * 100;

      if (percentage < 0) percentage = 0
      break;
  }

  return Math.round(percentage)
}

export const getMaintenanceLabel = (type, startValue, endValue, currentValue, messages) => {
  let percentage = 0;
  let title = ""

  switch (type) {
    case "time":
      let daysStart = moment.utc(startValue.toString())
      let daysEnd = moment.utc(endValue.toString())
      let daysNow = moment.utc(currentValue) || moment().utc()

      const diff = moment.duration(daysEnd.diff(daysStart));
      const diffNow = moment.duration(daysNow.diff(daysStart));

      percentage = (diffNow.asMinutes() / diff.asMinutes()) * 100
      if (percentage < 0) percentage = 0

      let currentTime = ""
      if (diffNow.asMonths() >= 1) currentTime = `${round(diffNow.asMonths(), 1)}  ${messages['vehicleDetailView_months']}`
      else if (diffNow.asDays() >= 1) currentTime = `${round(diffNow.asDays(), 1)}  ${messages['vehicleDetailView_days']}`
      else if (diffNow.asHours() >= 1) currentTime = `${round(diffNow.asHours(), 1)}  ${messages['vehicleDetailView_engineHours']}`
      else if (diffNow.asMinutes() >= 1) currentTime = `${round(diffNow.asMinutes(), 1)}  ${messages['vehicleDetailView_minutes']}`
      let totalTime = ""
      if (diff.asMonths() >= 1) totalTime = `${round(diff.asMonths(), 1)}  ${messages['vehicleDetailView_months']}`
      else if (diff.asDays() >= 1) totalTime = `${round(diff.asDays(), 1)}  ${messages['vehicleDetailView_days']}`
      else if (diff.asHours() >= 1) totalTime = `${round(diff.asHours(), 1)}  ${messages['vehicleDetailView_engineHours']}`
      else if (diff.asMinutes() >= 1) totalTime = `${round(diff.asMinutes(), 1)}  ${messages['vehicleDetailView_minutes']}`

      title = `(${Math.floor(percentage)}%) ${currentTime}/${totalTime}`;
      break;

    case "odometer":
      let totalOdometer = endValue - startValue
      //fix value
      currentValue = currentValue - startValue;
      //calculate
      percentage = (currentValue / totalOdometer) * 100;
      if (percentage < 0) percentage = 0

      title = `(${Math.round(percentage)}%) ${currentValue < 0 ? 0 : Math.round(currentValue)}/${Math.round(totalOdometer)} ${messages['vehicleDetailView_miles']}`;
      break;

    case "engineHours":
      let totalEngineH = endValue - startValue;
      //fix value
      currentValue = currentValue - startValue;
      //calculate
      percentage = (currentValue / totalEngineH) * 100;

      if (percentage < 0) percentage = 0

      title = `(${Math.round(percentage)}%) ${currentValue < 0 ? 0 : Math.round(currentValue)}/${Math.round(totalEngineH)} ${messages['vehicleDetailView_engineHours']}`;
      break;
  }

  return title
}

const toFiniteNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const number = parseFloat(value);
  return Number.isFinite(number) ? number : null;
};

// device_readings stores ecuEngineHours in hours but engineHours in seconds (legacy: the
// history was never converted), so each field is converted on its own before falling back
// to the other one. Returns hours, or null when the reading has no engine hours.
export const getReadingEngineHours = (reading, useEcuEngineHours) => {
  const ecuHours = toFiniteNumber(reading?.ecuEngineHours);
  const engineSeconds = toFiniteNumber(reading?.engineHours);
  let engineHours = null;
  if (engineSeconds !== null) {
    engineHours = engineSeconds / 3600;
  }

  if (useEcuEngineHours) {
    return ecuHours ?? engineHours;
  }
  return engineHours ?? ecuHours;
};

// Engine hours keep up to 2 decimals (e.g. 840.23); returns null when there's no numeric value.
export const roundEngineHours = (value) => {
  const hours = toFiniteNumber(value);
  if (hours === null) return null;
  return roundTo(hours, 2);
};
